export function isLocalDevelopment() {
  return process.env.NODE_ENV === 'development' && !(window as any).__POWERED_BY_QIANKUN__
}
